import axios from 'axios';
import { createPlaybackTracker } from './playbackTracker';

export default {
  mounted() {
    // Only the public player uses this mixin; editor/library previews are excluded.
    this.stopAnalyticsWatch = this.$watch('player', player => {
      this.clearPlaybackAnalytics();
      if (!player || !this.vid || !this.vid.id || !this.vid.permalinks) return;
      this.playbackAnalytics = createPlaybackTracker(player, this.vid, (payload, exiting) => {
        // Fetch keepalive works across the API origin, unlike an authenticated
        // dashboard client. Public playback never needs the owner's JWT.
        const base = axios.defaults.baseURL;
        const url = base ? `${base.replace(/\/$/, '')}/analytics/playback` : 'https://v1.gdapis.com/api/groovevideo/analytics/playback';
        fetch(url, { method: 'POST', credentials: 'omit', keepalive: !!exiting,
          headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).catch(() => {});
      });
      this.playbackAnalyticsTimer = setInterval(() => this.playbackAnalytics.flush(), 30000);
      this.playbackAnalyticsExit = () => this.playbackAnalytics.flush(true);
      this.playbackAnalyticsHidden = () => { if (document.visibilityState === 'hidden') this.playbackAnalyticsExit(); };
      window.addEventListener('pagehide', this.playbackAnalyticsExit);
      document.addEventListener('visibilitychange', this.playbackAnalyticsHidden);
    }, { immediate: true });
  },
  methods: {
    clearPlaybackAnalytics() {
    clearInterval(this.playbackAnalyticsTimer);
    window.removeEventListener('pagehide', this.playbackAnalyticsExit);
    document.removeEventListener('visibilitychange', this.playbackAnalyticsHidden);
    if (this.playbackAnalytics) this.playbackAnalytics.destroy();
    this.playbackAnalytics = null;
    },
  },
  beforeDestroy() {
    if (this.stopAnalyticsWatch) this.stopAnalyticsWatch();
    this.clearPlaybackAnalytics();
  },
};
